import React, { useState } from "react";

import { useCompanySettings } from "../hooks/useCompanySettings";
import { TAB } from "../constant/common";
import { TickerArea } from "./TickerArea";
import AmountSharesSelectionTabs from "./AmountSharesSelectionTabs";
import { useMainAppHeightAdjustment } from "../hooks/useMainAppHeightAdjustment";

const MainContent = () => {
  const companySettings = useCompanySettings();
  const [tab, setTab] = useState(companySettings.defaultTab || TAB.AMOUNT_INVESTED);
  useMainAppHeightAdjustment([tab]);

  return (
    <>
      <TickerArea />
      <AmountSharesSelectionTabs tab={tab} setTab={setTab} />
    </>
  );
};

export default MainContent;
